var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWireframes1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.803,
    height: 37.602,
    viewBox: "0 0 40.803 37.602",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes",
    transform: "translate(0.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Specialist---View-directory-profile-v2-_collapsed_",
    "data-name": "Specialist---View-directory-profile-v2-(collapsed)",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "office-referral"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-1",
    d: "M2.967,11.2V27.427h9.078V15.26h9.078V27.427H30.2V11.2",
    transform: "translate(2.403 8.174)",
    fill: "none",
    stroke: "#118847",
    strokeLinecap: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3",
    d: "M0,19.6,18.987,0,37.975,19.6",
    fill: "none",
    stroke: "#118847",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-5",
    d: "M14.093.747h6.713v6.76",
    transform: "translate(10.656 0.605)",
    fill: "none",
    stroke: "#118847",
    strokeLinecap: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWireframes1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Wireframes-1.4d1c3fc2ddcc64f897e69233a4815bef.svg";